export const qualityResources = {
  fr: {
    inspectionCard: { reference: "Référence d’inspection", reason: "Motif du contrôle" },
    portalView: {
      open: "En cours",
      finished: "Terminées",
      emptyOpen: "Aucune dérogation en attente de votre décision.",
      emptyFinished: "Aucune dérogation terminée.",

      originalExpiry: "Péremption actuelle",
      extension: "Prolongation demandée",
      requestedExpiry: "Péremption demandée",
      days: "{{count}} jour(s)",
      readOnly: "Cette demande est en consultation seule. Aucune décision partenaire enregistrée."
    },
    derogationCard: {
      reference: "Référence de dérogation",
      client: "Client",
      warehouse: "Entrepôt",
      item: "Article",
      hu: "Unité logistique (HU)",
      quantity: "Quantité concernée",
      location: "Emplacement",
      serial: "Numéros de série",
      reason: "Motif de la demande",
      asn: "Avis d’expédition (ASN)",
      receipt: "Réception",
      type: "Type de dérogation",
      description: "Désignation",
      lot: "Lot concerné",
      expiry: "Date de péremption",
      alternativeHu: "HU alternative",
      alternativeLot: "Lot alternatif",
      alternativeQuantity: "Quantité disponible sur l’alternative"
    },
    module: "Qualité",
    title: "Inspections qualité",
    derogations: { module: "Dérogations", title: "Gestion des dérogations", fefoTitle: "Dérogations FEFO", fefoLoadError: "Impossible de charger les dérogations FEFO." },
    searchPlaceholder: "Inspection, HU, article…",
    queues: {
      label: "Files qualité",
      inspections: "Inspections ({{count}})",
      shelfLife: "Dérogations de durée de vie ({{count}})"
    },
    tabs: { open: "À traiter", closed: "Terminées" },
    tabsMobile: { open: "À TRAITER", closed: "TERMINÉES" },
    filters: {
      warehouse: "Entrepôt", dateOrder: "Ordre de date",
      syntaxPlaceholder: "id:HU-001 raison:HU_DAMAGED statut:OPEN",
      syntaxHelp: "id:, article:, serie:, entrepot:, gare:, raison:, statut:, decision:, date:"
    },
    actions: {
      claim: "Prendre en charge", decide: "Décider", review: "Revoir", view: "Consulter",
      select: "Sélectionner une inspection", confirmDecision: "Confirmer la décision"
    },
    partnerActions: { ACCEPTED: "Accepter", REJECTED: "Rejeter" },
    portal: {
      loadError: "Impossible de charger les demandes de validation.",
      empty: "Aucune demande n’est actuellement soumise à votre organisation.",
      toDecide: "À décider", decided: "Décidée",
      dialogTitle: "Validation de {{number}}", decision: "Décision",
      recordedDecision: "Décision enregistrée : {{decision}}"
    },
    reasons: {
      HU_DAMAGED: "HU endommagée",
      MATERIAL_DAMAGE_SUSPECTED: "Dommage matière suspecté",
      RECEIPT_QUARANTINE: "Mise en quarantaine à la réception"
      , SHELF_LIFE_DEROGATION: "Dérogation de durée de vie"
    },
    dispositions: {
      RELEASED: "Libérée",
      REPACKAGING: "Reconditionnement",
      RETURN_TO_SUPPLIER: "Retour fournisseur",
      SCRAPPED: "Mise au rebut",
      ACCEPT_NEW_EXPIRY: "Nouvelle date acceptée",
      SUBMIT_TO_CUSTOMER: "Soumise au client",
      SUBMIT_TO_SUPPLIER: "Soumise au fournisseur",
      QUARANTINE: "Mise en quarantaine"
    },
    dispositionActions: {
      RELEASED: "Libérer et relancer la mise en stock",
      REPACKAGING: "Envoyer au reconditionnement",
      RETURN_TO_SUPPLIER: "Retourner au fournisseur",
      SCRAPPED: "Rebuter",
      ACCEPT_NEW_EXPIRY: "Accepter la nouvelle date de péremption",
      SUBMIT_TO_CUSTOMER: "Soumettre la dérogation au client",
      SUBMIT_TO_SUPPLIER: "Soumettre la dérogation au fournisseur",
      QUARANTINE: "Mettre en quarantaine"
    },
    labels: {
      inspection: "Inspection {{number}}", qualityInspection: "Inspection qualité",
      details: "Afficher le détail", itemTraceability: "Article et traçabilité",
      serialNumber: "S/N : {{numbers}}", assignedTo: "Affectée à {{user}}",
      decision: "Décision : {{decision}}", qualityDecision: "Décision qualité",
      derogationDecision: "Décision de dérogation",
      expiryRequest: "Demande d’extension",
      originalExpiry: "Péremption actuelle : {{date}}",
      requestedExtension: "Extension demandée : {{days}} jours",
      requestedExpiry: "Nouvelle péremption demandée : {{date}}",
      customerRequestSubmitted: "Soumise à {{partner}} — validation niveau {{level}} en attente.",
      partnerDecisionPendingExecution: "Décision partenaire à exécuter : {{decision}} — {{comment}}",
      acceptedTerms: "Conditions acceptées par le partenaire",
      acceptedExtension: "Extension acceptée : {{days}} jours",
      acceptedExpiry: "Nouvelle péremption acceptée : {{date}}",
      approvedExtensionDays: "Durée d’extension validée (jours)",
      repackagingStation: "Gare de reconditionnement", departureStation: "Gare de départ",
      decisionComment: "Commentaire de décision"
    },
    help: {
      requiredThree: "Obligatoire — minimum 3 caractères",
      extensionAdjustable: "La durée proposée peut être ajustée avant validation."
    },
    empty: { all: "Aucune inspection qualité." },
    errors: {
      load: "Impossible de charger les inspections.",
      claim: "Prise en charge impossible.", decision: "Décision impossible.",
      noCompatibleStation: "Aucune gare active compatible n’est configurée pour cet entrepôt."
    }
  },
  en: {
    inspectionCard: { reference: "Inspection reference", reason: "Inspection reason" },
    portalView: {
      open: "In progress",
      finished: "Completed",
      emptyOpen: "No derogation is awaiting your decision.",
      emptyFinished: "No completed derogations.",

      originalExpiry: "Current expiry",
      extension: "Requested extension",
      requestedExpiry: "Requested expiry",
      days: "{{count}} day(s)",
      readOnly: "This request is read-only. No partner decision has been recorded."
    },
    derogationCard: {
      reference: "Derogation reference",
      client: "Customer",
      warehouse: "Warehouse",
      item: "Material",
      hu: "Handling unit (HU)",
      quantity: "Affected quantity",
      location: "Location",
      serial: "Serial numbers",
      reason: "Request reason",
      asn: "Shipping notice (ASN)",
      receipt: "Receipt",
      type: "Derogation type",
      description: "Description",
      lot: "Affected lot",
      expiry: "Expiry date",
      alternativeHu: "Alternative HU",
      alternativeLot: "Alternative lot",
      alternativeQuantity: "Available alternative quantity"
    },
    module: "Quality",
    title: "Quality inspections",
    derogations: { module: "Derogations", title: "Derogation management", fefoTitle: "FEFO derogations", fefoLoadError: "FEFO derogations could not be loaded." },
    searchPlaceholder: "Inspection, HU, material…",
    queues: {
      label: "Quality queues",
      inspections: "Inspections ({{count}})",
      shelfLife: "Shelf-life derogations ({{count}})"
    },
    tabs: { open: "To process", closed: "Completed" },
    tabsMobile: { open: "TO PROCESS", closed: "COMPLETED" },
    filters: {
      warehouse: "Warehouse", dateOrder: "Date order",
      syntaxPlaceholder: "id:HU-001 reason:HU_DAMAGED status:OPEN",
      syntaxHelp: "id:, item:, serial:, warehouse:, station:, reason:, status:, decision:, date:"
    },
    actions: {
      claim: "Take charge", decide: "Decide", review: "Review", view: "View",
      select: "Select an inspection", confirmDecision: "Confirm decision"
    },
    partnerActions: { ACCEPTED: "Accept", REJECTED: "Reject" },
    portal: {
      loadError: "Unable to load approval requests.",
      empty: "No request is currently assigned to your organization.",
      toDecide: "To decide", decided: "Decided",
      dialogTitle: "Approval of {{number}}", decision: "Decision",
      recordedDecision: "Recorded decision: {{decision}}"
    },
    reasons: {
      HU_DAMAGED: "HU damaged",
      MATERIAL_DAMAGE_SUSPECTED: "Suspected material damage",
      RECEIPT_QUARANTINE: "Quarantined at receipt"
      , SHELF_LIFE_DEROGATION: "Shelf-life derogation"
    },
    dispositions: {
      RELEASED: "Released",
      REPACKAGING: "Repackaging",
      RETURN_TO_SUPPLIER: "Return to supplier",
      SCRAPPED: "Scrapped",
      ACCEPT_NEW_EXPIRY: "New expiry date accepted",
      SUBMIT_TO_CUSTOMER: "Submitted to customer",
      SUBMIT_TO_SUPPLIER: "Submitted to supplier",
      QUARANTINE: "Quarantined"
    },
    dispositionActions: {
      RELEASED: "Release and restart putaway",
      REPACKAGING: "Send to repackaging",
      RETURN_TO_SUPPLIER: "Return to supplier",
      SCRAPPED: "Scrap",
      ACCEPT_NEW_EXPIRY: "Accept new expiry date",
      SUBMIT_TO_CUSTOMER: "Submit derogation to customer",
      SUBMIT_TO_SUPPLIER: "Submit derogation to supplier",
      QUARANTINE: "Quarantine"
    },
    labels: {
      inspection: "Inspection {{number}}", qualityInspection: "Quality inspection",
      details: "Show details", itemTraceability: "Material and traceability",
      serialNumber: "S/N: {{numbers}}", assignedTo: "Assigned to {{user}}",
      decision: "Decision: {{decision}}", qualityDecision: "Quality decision",
      derogationDecision: "Derogation decision",
      expiryRequest: "Expiry extension request",
      originalExpiry: "Current expiry: {{date}}",
      requestedExtension: "Requested extension: {{days}} days",
      requestedExpiry: "Requested new expiry: {{date}}",
      customerRequestSubmitted: "Submitted to {{partner}} — level {{level}} approval pending.",
      partnerDecisionPendingExecution: "Partner decision to execute: {{decision}} — {{comment}}",
      acceptedTerms: "Terms accepted by the partner",
      acceptedExtension: "Accepted extension: {{days}} days",
      acceptedExpiry: "Accepted new expiry: {{date}}",
      approvedExtensionDays: "Approved extension duration (days)",
      repackagingStation: "Repackaging station", departureStation: "Departure station",
      decisionComment: "Decision comment"
    },
    help: {
      requiredThree: "Required — at least 3 characters",
      extensionAdjustable: "The proposed duration can be adjusted before approval."
    },
    empty: { all: "No quality inspection." },
    errors: {
      load: "Unable to load inspections.",
      claim: "Unable to take charge.", decision: "Unable to record the decision.",
      noCompatibleStation: "No compatible active station is configured for this warehouse."
    }
  }
} as const;
